module.exports = __webpack_public_path__ + "img/8.c41c9d61.jpg";